package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.theme.name
import org.jetbrains.compose.web.css.*
import org.lennycodes.hldi.constants.HLDITheme

val ScrollToTopStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .bottom(32.px)
            .right(32.px)
            .width(50.px)
            .height(50.px)
            .borderRadius(50.percent)
            .backgroundColor(org.jetbrains.compose.web.css.Color.transparent)
            .border(2.px, LineStyle.Solid, Color.rgba(255, 255, 255, 0.3f))
            .color(Colors.White)
            .fontSize(20.px)
            .cursor(Cursor.Pointer)
            .display(DisplayStyle.None)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 15.px,
                color = org.jetbrains.compose.web.css.Color.transparent
            )
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
            .zIndex(1000)
    }

    hover {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 8.px,
                blurRadius = 25.px,
                color =Colors.Indigo
            )
    }

    active {
        Modifier.translateY(0.px)
    }
}

val ScrollToTopVisibleStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .backgroundColor(Colors.Indigo)
            .border(2.px, LineStyle.Solid, org.jetbrains.compose.web.css.Color.transparent)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 15.px,
                color = Colors.Indigo
            )
            .styleModifier {
                property("animation", "${FadeInUpKeyframes.name} 0.3s ease-out")
            }
    }
}